var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMktTeamActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 21H21V52H38.687L52 38.0023V21Z",
    fill: "#1565D8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 31,
    transform: "matrix(-1 0 0 1 21 21)",
    fill: "#1565D8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 21,
    width: 52,
    height: 21,
    transform: "rotate(-180 52 21)",
    fill: "#1565D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 25C31.5 25.67 31.5 26.33 31.5 27C32.7 27 34.26 27 35.5 27C35.5 26.33 35.5 25.67 35.5 25C34.26 25 32.7 25 31.5 25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 31.61C30.46 32.32 31.71 33.26 32.7 34C33.1 33.47 33.5 32.93 33.9 32.4C32.91 31.66 31.66 30.72 30.7 30C30.3 30.54 29.9 31.08 29.5 31.61Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9 19.6C33.5 19.07 33.1 18.53 32.7 18C31.71 18.74 30.46 19.68 29.5 20.4C29.9 20.93 30.3 21.47 30.7 22C31.66 21.28 32.91 20.35 33.9 19.6Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 23C16.4 23 15.5 23.9 15.5 25V27C15.5 28.1 16.4 29 17.5 29H18.5V33H20.5V29H21.5L26.5 32V20L21.5 23H17.5ZM22.53 24.71L24.5 23.53V28.47L22.53 27.29L22.05 27H21.5H17.5V25H21.5H22.05L22.53 24.71Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 25.9999C29 24.6699 28.42 23.4699 27.5 22.6499V29.3399C28.42 28.5299 29 27.3299 29 25.9999Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M22.53 24.71L24.5 23.53V28.47L22.53 27.29L22.05 27H21.5H17.5V25H21.5H22.05L22.53 24.71Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMktTeamActive);
export default __webpack_public_path__ + "static/media/mkt-team-active.99a88611bfde0ba187069ad7b2579b30.svg";
export { ForwardRef as ReactComponent };